import script from "./WelcomeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeModal.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeModal.vue?vue&type=style&index=0&id=c0a5a270&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0a5a270"]])

export default __exports__